import React from 'react'
import noop from 'lodash/noop'
import Button from '@active/react-ui/Button'
import LinkButton from '@active/react-ui/LinkButton'
import {
  bool, func, shape, string,
} from 'prop-types'
import I18nMessage from '../../../common/I18nMessage'
import { handleKeyboardEvent } from '../../../../shared/utils/commonUtils'
import './AuthenticationItem.scss'

function AuthenticationItem({
  authenticationName,
  verificationCode,
  contact,
  markConfig: {
    name: markName,
    isPrimary,
    triggerCallback: markCallback = noop,
  } = {},
  operatorConfig: {
    name: operatorName,
    triggerCallback: operatorCallback = noop,
  } = {},
}) {
  return (
    <div className="authentication-item">
      <div className="authentication-item-info">
        <div className="authentication-name">
          <I18nMessage id={authenticationName} />
        </div>
        <div className="verification-code">
          <I18nMessage id={verificationCode} />
        </div>
        <div className="contact">
          {contact && <div className="contact-info">{contact}</div>}
          {operatorName && (
            <LinkButton onClick={operatorCallback} onKeyDown={handleKeyboardEvent(operatorCallback, 'Enter')}>
              <I18nMessage id={operatorName} />
            </LinkButton>
          )}
        </div>
      </div>
      {markName && (isPrimary
        ? (
          <div className="primary-label">
            <i className="ic-check-o" />
            <I18nMessage id={markName} />
          </div>
        )
        : (
          <Button
            onClick={markCallback}
            onKeyDown={handleKeyboardEvent(markCallback, 'Enter')}
            size="sm"
            type="secondary"
          >
            <I18nMessage id={markName} />
          </Button>
        )
      )}
    </div>
  )
}

AuthenticationItem.propTypes = {
  authenticationName: string,
  verificationCode: string,
  contact: string,
  markConfig: shape({
    name: string,
    isPrimary: bool,
    triggerCallback: func,
  }),
  operatorConfig: shape({
    name: string,
    triggerCallback: func,
  }),
}

AuthenticationItem.defaultProps = {
  authenticationName: undefined,
  verificationCode: undefined,
  contact: undefined,
  markConfig: {},
  operatorConfig: {},
}
export default AuthenticationItem
